const MOBILE_INSURANCE_PLANS = {
    BASIC: 'BASIC',
    MEDIUM: 'MEDIUM',
    HIGH: 'HIGH'
};

const MOBILE_INSURANCE_PLANS_PERCENTAGE = {
    BASIC: 50,
    MEDIUM: 35,
    HIGH: 20
}

module.exports = {
    MOBILE_INSURANCE_PLANS,
    MOBILE_INSURANCE_PLANS_PERCENTAGE
}